import React from "react";
import { Outlet } from "react-router-dom";
import PolarisSidebar from "./PolarisSidebar";
import { useMyAvatar } from "../utils/profilePictureUtils";
import { useAuth } from "../contexts/AuthContext";
import "../styles/polaris-admin.css";
import "../styles/layout.css";

export default function PolarisLayout() {
    const { isAuthenticated } = useAuth();
    const { avatarUrl } = useMyAvatar(isAuthenticated);

    return (
        <div className="polaris-layout with-rail-sidebar">
            <PolarisSidebar profileImageUrl={avatarUrl} />
            <div className="polaris-main">
                <header className="polaris-header">
                    <div className="polaris-header-title">Polaris Admin Portal</div>
                </header>
                <main className="polaris-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
